import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as moment from "moment";
import * as _ from "lodash";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

import { ViewerUtils } from "../common/viewerUtils";
import { ContentTable, ContentText, StyleDictionary, TDocumentDefinitions } from "pdfmake/interfaces";

const tableRows = (models) => {
    return models.map(d => {
        const url = `${ViewerUtils.sdUrl()}/${d.queryId}`;
        return [d.modelName || d.name, { style: "link", text: url, link: url }, { style: "qr", qr: url, fit: "100", margin: [0, 10, 0, 10]}];
    });
}

const createPdf = async (projectUrl, projectName, models) => {

    var dd: TDocumentDefinitions = {
        content: [
            {
                style: "subheader",
                text: "Project"
            } as ContentText,
            {
                style: "tableExample",
                table: {
                    body: [[projectName, { rowSpan: 2, style: "qr", qr: projectUrl, fit: "100" }], [{ style: "link", text: projectUrl, link: projectUrl }]]
                },
                layout: "noBorders"
            } as ContentTable,
            {
                style: "subheader",
                text: "Models"
            } as ContentText,
            {
                style: "tableExample",
                table: {
                    widths: ["40%", "40%", "20%"],
                    body: tableRows(models),
                    dontBreakRows: true
                }
            } as ContentTable,
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            tableExample: {
                margin: [0, 5, 0, 15]
            } as StyleDictionary
        }
    };

    const filename =
        `${projectName}_${moment()
            .format("YYYYMMDD-HHmm")}.pdf`;

    const pdf = pdfMake.createPdf(dd);
    
    pdf.download(filename);
    //pdf.open({}, window);
}

export { createPdf }